let load = true;
const App = {
    init: async () => {
        if (load) {
            await App.sizeSet();
            load = false;


            let cursor = document.querySelector("#cursor");
            document.addEventListener('mousemove', (e) => {
                e.preventDefault();
                e.stopPropagation();
                let offsetX = e.clientX;
                let offsetY = e.clientY;
                cursor.style.left = offsetX + "px";
                cursor.style.top = offsetY + "px";


                let links = document.querySelectorAll('a');
                links.forEach(item => {
                    item.addEventListener("mouseenter", mouseActive, true);
                    item.addEventListener("mouseleave", mouseInactive, true);
                });

                let cursore = document.querySelectorAll('.cursore');
                cursore.forEach(item => {
                    item.addEventListener("mouseenter", mouseActive, true);
                    item.addEventListener("mouseleave", mouseInactive, true);
                });
            });

            function mouseActive() {
                let cursor = document.querySelector("#cursor");
                cursor.classList.add("active");
                cursor.classList.remove("hidden");
            }

            function mouseInactive() {
                let cursor = document.querySelector("#cursor");
                cursor.classList.remove("active");
                cursor.classList.remove("hidden");
            }

            let main = document.querySelector("#main");
            let video = document.querySelector("#video");
            let videoClose = document.querySelector("#video-close");
            let showVideo = document.querySelector("#show-video");
            let videoDesktop = document.querySelector("#video-desktop");
            let videoMobile = document.querySelector("#video-mobile");

            showVideo.addEventListener("click", () => {
                if (!video.classList.contains("active")) {
                    
                    video.classList.add("active");
                    main.classList.add("active");
                    videoClose.classList.add("active");

                    videoDesktop.currentTime = 0;
                    videoDesktop.load();
                    videoDesktop.play();

                    // if (!App.isMobile) {
                    //     videoDesktop.currentTime = 0;
                    //     videoDesktop.load();
                    //     videoDesktop.play();
                    // } else {
                    //     videoMobile.currentTime = 0;
                    //     videoMobile.load();
                    //     videoMobile.play();
                    // }

                }
            })



            if (videoDesktop) {
                videoDesktop.addEventListener("click", () => {
                    if (!videoDesktop.paused) {
                        videoDesktop.pause();
                    } else {
                        videoDesktop.play();
                    }
                })
            }

            // if (videoMobile) {
            //     videoMobile.addEventListener("click", () => {
            //         if (!videoMobile.paused) {
            //             videoMobile.pause();
            //         } else {
            //             videoMobile.play();
            //         }
            //     })
            // }


            videoClose.addEventListener("click", () => {
                // videoDesktop.pause();
                // videoMobile.pause();
                // main.classList.remove("active");
                video.classList.remove("active");
                videoClose.classList.remove("active");
                videoDesktop.pause();
                videoDesktop.currentTime = 0;
            })



            window.addEventListener('resize', () => {
                if (videoDesktop)
                    videoDesktop.pause();
                if (videoMobile)
                    videoMobile.pause();
                main.classList.remove("active");
                video.classList.remove("active");
                videoClose.classList.remove("active");
            });




        }
    },
    sizeSet: () => {

        App.width = (window.innerWidth || document.documentElement.clientWidth);
        App.height = (window.innerHeight || document.documentElement.clientHeight);
        if (App.width <= 768)
            App.isMobile = true;
        if (App.isMobile) {
            if (App.width > 768) {
                App.isMobile = false;
            }
        }
    }
};

export default App;

document.addEventListener("DOMContentLoaded", () => {
    App.init();
    window.addEventListener('resize', App.sizeSet);

});